import { object, string } from 'yup';

import { ICrowdCellsConfigPreset } from '@interfaces/crowdcell/crowdCells';

import { getMaxLengthErrMsg, mandatoryErrMessage } from '@constants/validationConstants';
import { MAX_70_LENGTH, MAX_250_LENGTH } from '@constants/validationMessages';

export const getSchema = (presets: ICrowdCellsConfigPreset[], isEdit: boolean) => {
	return object({
		name: string()
			.nullable()
			.max(MAX_70_LENGTH, getMaxLengthErrMsg('Preset Name', MAX_70_LENGTH))
			.required(mandatoryErrMessage('Preset Name'))
			.test('is-unique', 'Preset Name must be unique', (value) => {
				if (isEdit) return true;

				return !presets.some((preset: ICrowdCellsConfigPreset) => preset.name === value);
			}),
		comment: string()
			.max(MAX_250_LENGTH, getMaxLengthErrMsg('Comment', MAX_250_LENGTH)),
	});
};
